export type RequirementLevel = 'Primary' | 'Supplemental' | 'None';

export function requirementFromAttribute(value: unknown): RequirementLevel {
  if (value === 'Primary' || value === 'Supplemental' || value === 'None') {
    return value;
  }
  return 'Primary';
}

// Share of the load this system must carry. Primary is the whole load,
// Supplemental is the configured fraction (the existing equipment covers the
// rest), None is nothing.
export function heatingWeightForSpace(
  heatingValue: unknown,
  supplementalWeight: number
): number {
  const requirement = requirementFromAttribute(heatingValue);
  if (requirement === 'Supplemental') return supplementalWeight;
  if (requirement === 'None') return 0;
  return 1;
}

// The load itself. A space this system does not condition contributes nothing;
// Supplemental still counts in full. The share above is a separate number.
export function requirementLoadWeight(value: unknown): number {
  return requirementFromAttribute(value) === 'None' ? 0 : 1;
}

export function aggregateRequirementLevel(values: unknown[]): RequirementLevel {
  if (values.length === 0) return 'Primary';
  let result: RequirementLevel = 'None';
  for (const value of values) {
    const requirement = requirementFromAttribute(value);
    if (requirement === 'Primary') return 'Primary';
    if (requirement === 'Supplemental') {
      result = 'Supplemental';
    }
  }
  return result;
}
